module.exports = __webpack_public_path__ + "img/section6ModelMZh.b1acbc70.png";